import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import { HeaderTypes } from "@Src/types/api-response-interface";
import { Currency } from "@Constants/constants";

const initialState = {
  loading: false,
  user: null,
  loginError: "",
  showProfileSidebar: false,
  showWebSidebar: true,
  showFooter: true,
  manageWebSidebar: true,
  manageMobSidebar: true,
  activeHeader: HeaderTypes.MAIN_HEADER,
  currency: Currency.INR,
  subscriptionCart: null,
  manageWebHeader: false,
  practiceViewAllPage: true,
  viewAllPage: true,
  searchAllPage: true,
  upcomingAllPage: true,
};

const globalSlice = createSlice({
  name: "global",
  initialState,
  reducers: {
    showSpinner: (state) => {
      state.loading = true;
    },
    hideSpinner: (state) => {
      state.loading = false;
    },
    manageProfileSidebar: (state, action) => {
      state.showProfileSidebar = action.payload;
    },
    manageWebSidebar: (state, action) => {
      state.manageWebSidebar = action.payload;
    },
    manageMobSidebar: (state, action) => {
      state.manageMobSidebar = action.payload;
    },
    setActiveHeader: (state, action) => {
      state.activeHeader = action.payload;
    },
    showWebSidebar: (state, action) => {
      state.showWebSidebar = action.payload;
    },
    showFooter: (state, action) => {
      state.showFooter = action.payload;
    },
    setAppCurrency: (state, action) => {
      state.currency = action.payload;
    },
    setSubscriptionCart: (state, action) => {
      state.subscriptionCart = action.payload;
    },
    setManageWebHeader: (state, action) => {
      state.manageWebHeader = action.payload;
    },
    togglePracticeView: (state, action) => {
      state.practiceViewAllPage = action.payload;
    },
    toggleViewAll: (state, action) => {
      state.viewAllPage = action.payload;
    },
    toggleSearchAllPage: (state, action) => {
      state.viewAllPage = action.payload;
    },
    toggleUpcomingAllPage: (state, action) => {
      state.upcomingAllPage = action.payload;
    },
  },
});

export const {
  showSpinner,
  hideSpinner,
  manageWebSidebar,
  manageMobSidebar,
  manageProfileSidebar,
  setActiveHeader,
  showWebSidebar,
  showFooter,
  setAppCurrency,
  setSubscriptionCart,
  setManageWebHeader,
  togglePracticeView,
  toggleViewAll,
  toggleSearchAllPage,
  toggleUpcomingAllPage,
} = globalSlice.actions;
export default globalSlice.reducer;
